import { Injectable, EventEmitter } from '@angular/core';

import { Principal } from '../auth/principal.service';
import { CoreConfigService } from '../config/core-config.service';
import { UserContextService } from './user-context.service';
import { AppSettingService } from './app-setting.service';
import { ReadyState, ReadyStateFlag } from './ready-state.model';
import { AppSwitcherService } from './app-switcher.service';
import { OfficeSwitcherService } from './office-switcher.service';


@Injectable({ providedIn:'root' })
export class AppStateService {

    private _readyState:ReadyStateFlag|string;

    // private lastEmitMessage = null;

    readyStateChange: EventEmitter<ReadyState> = new EventEmitter();

    constructor(
        private principal: Principal,
        private configService: CoreConfigService,
        private userContext: UserContextService,
        private appSettings: AppSettingService,
        private appSwitcher: AppSwitcherService,
        private officeSwitcher: OfficeSwitcherService,
    ) {
        this.principal.authenticationStateChange.subscribe(account=>this.checkReady());
        this.userContext.dataChange.subscribe(data=>this.checkReady());
        this.appSwitcher.readyStateChange.subscribe(state=>this.checkReady(state));
        this.officeSwitcher.readyStateChange.subscribe(state=>this.checkReady(state));
        this.appSettings.officeSettingReadyStateChange.subscribe(state=>this.checkReady(state));

        this.checkReady();
    }

    private checkReady(state?:ReadyState){
        if(state&&state.state != ReadyStateFlag.READY){
            this._readyState = state.state;
            this.readyStateChange.emit(state);
        }else{
            this.readyStateChange.emit(this.readyState);
        }
        // console.log("AppStateService.checkReady() ->", state, this._readyState, this.readyState);
    }

    get readyState():ReadyState{
        return {state: this.isReady?ReadyStateFlag.READY:ReadyStateFlag.LOADING};
    }

    get isReady(){
        
        if(!this.userContext.isAuthenticated||this.userContext.currentUser==null){
            // console.log("用户account信息未加载完成");
            return false;
        }

        if(!this.appSwitcher.isReady){
            // console.log("应用列表未加载完成");
            return false;
        }

        const currentApp = this.userContext.currentApp;
        if(this.appSwitcher.forbidden||currentApp==null){
            // console.log("当前用户没有权限！");
            return true;
        }

        if(!this.officeSwitcher.isReady){
            // console.log("当前机构未加载完成");
            return false;
        }

        const currentOffice = this.userContext.currentOffice;
        const officeLevel = currentOffice?currentOffice.officeType:null;
        if(currentApp&&currentApp.bindOfficeLevel != officeLevel){
            // console.log("机构等级与应用不符");
            return false;
        }

        if(currentOffice!=null&&this.appSettings.getOfficeSettings(currentOffice)==null) {
            // console.log("机构配置未加载完成, currentOffice=", currentOffice);
            return false;
        }

        // console.log("AppStateService.isReady() -> true");
        return true;
    }
}
